module.exports = __webpack_public_path__ + "static/img/wake.146a383c.svg";